export default __webpack_public_path__ + "static/media/pic_pl.65ae8223.jpg";